<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t('View Income information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <v-flex xs12 style="text-align: center" class="only-for-print" pb-3>
                  <strong>{{ $t('Incomes') }}</strong>
                </v-flex>

                <table style="width: 100%">
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Income Number') }}
                      </div>
                      <strong>{{ incomeInfo.income_number || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Income Type') }}
                      </div>
                      <strong>{{ incomeInfo.income_name || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Outlet') }}</div>
                      <strong>{{ incomeInfo.outlet_name || '-' }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Payer Name') }}
                      </div>
                      <strong>{{ incomeInfo.payer || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Amount') }} ({{ systemCurrency }})</div>
                      <strong v-if="incomeInfo.amount">
                        {{ incomeInfo.amount | currency }}
                      </strong>
                      <strong v-else>-</strong>
                    </td>
                    <td class="td-padding-bottom" colspan="2">
                      <div class="caption no-select">
                        {{ $t('Payment Date') }}
                      </div>
                      <strong v-if="incomeInfo.payment_date">
                        {{ incomeInfo.payment_date }}
                      </strong>
                      <strong v-else>-</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Property Number') }}
                      </div>
                      <strong>{{ incomeInfo.property_no || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ 'Contract Number' }}</div>
                      <strong>
                        {{ incomeInfo.contract_no || '-' }}
                      </strong>
                    </td>
                    <td class="td-padding-bottom" colspan="2">
                      <div class="caption no-select">
                        {{ $t('Organizer') }}
                      </div>
                      <strong>
                        {{ incomeInfo.contract_organizer || '-' }}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ 'Address' }}</div>
                      <strong>
                        {{ incomeInfo.place || '-' }}
                      </strong>
                    </td>
                    <td class="td-padding-bottom" colspan="2">
                      <div class="caption no-select">{{ $t('Note') }}</div>
                      <strong v-html="lnToBr(incomeInfo.note) || '-'" />
                    </td>
                  </tr>
                </table>

                <!-- <v-flex xs4 class="pb-3">
                  <div class="caption no-select">{{ $t('Income Number') }}</div>
                  <strong>{{ incomeInfo.income_number || '-' }}</strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">{{ $t('Income Type') }}</div>
                  <strong>{{ incomeInfo.income_name || '-' }}</strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">{{ $t('Outlet') }}</div>
                  <strong>{{ incomeInfo.outlet_name || '-' }}</strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Payer Name') }}
                  </div>
                  <strong>{{ incomeInfo.payer || '-' }}</strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Amount') }} ({{ systemCurrency }})
                  </div>
                  <strong v-if="incomeInfo.amount">
                    {{ incomeInfo.amount | currency }}
                  </strong>
                  <strong v-else>-</strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">{{ $t('Payment Date') }}</div>
                  <strong v-if="incomeInfo.payment_date">
                    {{ incomeInfo.payment_date }}
                  </strong>
                  <strong v-else>-</strong>
                </v-flex>
                <v-flex xs12 class="pb-3">
                  <div class="caption no-select">{{ $t('Note') }}</div>
                  <strong v-html="lnToBr(incomeInfo.note) || '-'" />
                </v-flex> -->

                <invoice-footer
                  :showSignatureSection="true"
                  :accountantName="incomeInfo.accountant"
                  :payerRecipientName="incomeInfo.payer"
                  :payerOrRecipient="$t('Payer')"
                  class="only-for-print"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency
    }
  },

  computed: {
    ...mapGetters({
      incomeInfo: 'incomes/getIncomeInfo'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe() {
      // helpers.doPrinting()
      let onlyForPrint = document.querySelectorAll('.only-for-print')
      let notPrintable = document.querySelectorAll('.not-printable')
      let invoiceContent = document.querySelector('.invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      theDialogContent.classList.remove('grey')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })

      this.$htmlToPaper('printArea', () => {
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
      })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
